module.exports = __webpack_public_path__ + "static/media/icon_183.e1fc38ef.svg";